module.exports = __webpack_public_path__ + "img/setting-step-seven.626db283.png";